<template>
  <component :tickets="tickets" :layout="layout" :is="tableComponent" />
</template>

<script>
  import { mapState } from 'vuex'
  import TableSimple from '@/components/table/TableSimple'
  import TableCols from '@/components/table/TableCols'
  import { layouts } from '@/app/const/settings'
  import TableState from '@/components/table/TableState.vue'
  import TableAd from '@/components/table/TableAd.vue'
  import TableVerticalAd from '@/components/table/TableVerticalAd.vue'
  import TableDiffClients from '@/components/table/TableDiffClients.vue'
  import ClientsQueue from '@/app/model/clients/clients-queue'

  const AVAILABLE_COMPONENT = {
    [layouts.default]: TableSimple,
    [layouts.col2]: TableCols,
    [layouts.col3]: TableCols,
    [layouts.colAd]: TableAd,
    [layouts.col2State]: TableState,
    [layouts.col2DiffClients]: TableDiffClients,
    [layouts.col1Ad]: TableVerticalAd,
    [layouts.col2Ad]: TableVerticalAd
  }

  export default {
    name: 'TableManager',
    props: {
      tickets: {
        type: [Array, ClientsQueue]
      }
    },
    computed: {
      ...mapState({
        guiSettings: state => state.gui.settings
      }),
      layout () {
        return this.guiSettings.layout.code
      },
      tableComponent () {
        return AVAILABLE_COMPONENT[this.layout]
      }
    }
  }
</script>
